import { useCallback, useContext, useEffect, useState } from 'react'
import GeoContext from 'contexts/geoContext'
import useFeatureFlag from 'hooks/Optimizely/useFeatureFlag'
import { OptimizelyFeatureFlags } from 'constants/optimizely'
import { getCookies, setCookie } from 'lib/web/cookieUtils'
import { daysInSeconds } from 'lib/datetime/durationInSeconds'

const COOKIE_NAME = 'le_live_prompt_dismissed'
const COOKIE_TTL = daysInSeconds(7)
const ENTRY_DELAY_MS = 2000
const EVENT_EXPIRY_DATE = new Date('2026-05-17T23:59:59+10:00')

function useLeLivePrompt() {
  const [show, setShow] = useState(false)
  const isEnabled = useFeatureFlag(OptimizelyFeatureFlags.leLivePopup)
  const { geoStateName } = useContext(GeoContext)

  const isVic = geoStateName?.toLowerCase() === 'victoria'
  const isExpired = new Date() > EVENT_EXPIRY_DATE
  const isDismissed = typeof window !== 'undefined' && getCookies()[COOKIE_NAME] === 'true'
  const isDevPreview = typeof window !== 'undefined' && window.localStorage.getItem('le_live_popup_preview') === 'true'

  const canShow = isDevPreview || (isEnabled && isVic && !isExpired && !isDismissed)

  useEffect(() => {
    if (!canShow) return
    const timeout = setTimeout(() => setShow(true), ENTRY_DELAY_MS)
    return () => clearTimeout(timeout)
  }, [canShow])

  const dismiss = useCallback(() => {
    setShow(false)
    setCookie(COOKIE_NAME, 'true', COOKIE_TTL, '/', 'Lax')
  }, [])

  return { show, dismiss }
}

export default useLeLivePrompt
